import MuiCheckbox, { CheckboxProps } from "@mui/material/Checkbox";

const Checkbox: React.FC<CheckboxProps> = MuiCheckbox;

export default Checkbox;

export type { CheckboxProps };
